// Versión de la interfaz de usuario
const UI_VERSION = "1.3.6";

import { queueEmail } from "./emailQueueService";

// Simple wrapper for SMTPJS email sending
export const sendEmail = async ({ to, subject, body }) => {
  const maxRetries = 3;
  let retryCount = 0;
  const timeout = 60000; // 60 segundos de timeout

  // URL de la función de Firebase
  const emailEndpoint = "https://us-central1-gana-con-bendicion-en-mano.cloudfunctions.net/sendEmailHttp";

  const sendRequest = async () => {
    try {
      // console.log(
      //   `[EmailService] Intentando enviar email a ${to} (intento ${retryCount + 1}/${maxRetries})`
      // );
      
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), timeout);

      const response = await fetch(emailEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Origin: window.location.origin,
        },
        body: JSON.stringify({
          to,
          subject,
          html: body,
        }),
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      // Si la respuesta no es OK, intentar parsear el error
      if (!response.ok) {
        let errorMessage;
        try {
          const errorData = await response.json();
          errorMessage = errorData.error || "Error desconocido";
        } catch {
          errorMessage = `Error ${response.status}: ${response.statusText}`;
        }
        throw new Error(errorMessage);
      }

      const result = await response.json();
      //console.log(`[EmailService] Email enviado exitosamente a ${to}`);
      return result;
    } catch (error) {
      if (error.name === "AbortError") {
        console.error("[EmailService] Timeout al enviar el email");
        throw new Error("Timeout al enviar el email");
      }
      console.error("[EmailService] Error al enviar email:", error);
      throw error;
    }
  };

  while (retryCount < maxRetries) {
    try {
      return await sendRequest();
    } catch (error) {
      retryCount++;
      if (retryCount < maxRetries) {
        const delay = 2000 * Math.pow(2, retryCount); // Backoff exponencial más agresivo
        console.warn(
          `[EmailService] Reintentando envío de email (intento ${retryCount + 1}/${maxRetries}) en ${delay}ms...`
        );
        await new Promise((resolve) => setTimeout(resolve, delay));
      } else {
        console.error("[EmailService] Se agotaron los reintentos de envío de email");
        throw error;
      }
    }
  }
};

// Notify client after an order or event
export function notifyClient(clientEmail, details) {
  const body = `Hola,\n\nGracias por tu solicitud.\nDetalles: ${JSON.stringify(
    details
  )}\n\nSaludos.`;
  return queueEmail({ to: clientEmail, subject: "Confirmación de solicitud", body });
}

// Notify admin about new client action
export function notifyAdmin(details) {
  const adminEmail = "notificaciones@rgcm.pixeocreativestudio.com";
  const body = `Nueva acción registrada:\n\nDetalles: ${JSON.stringify(details)}`;
  return queueEmail({ to: adminEmail, subject: "Nueva notificación de usuario", body });
}

const emailTemplate = (content) => `
<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>GANA CON BENDICION EN MANOS</title>
  <!-- Preheader: visible in email preview, hidden in body -->
  <style type="text/css">
    .preheader { display: none !important; visibility: hidden; mso-hide: all; font-size: 1px; line-height: 1px; max-height: 0; max-width: 0; opacity: 0; overflow: hidden; }
    @media screen and (max-width:600px) {
      .container { width: 100% !important; }
      .stack { display: block !important; width: 100% !important; }
      .btn { padding: 12px 20px !important; font-size: 16px !important; }
    }
  </style>
</head>
<body style="Margin:0;padding:0;background-color:#f4f4f4;">
  <span class="preheader">¡Gracias por confiar en Rifa GANA CON BENDICION EN MANOS!</span>
  <table border="0" cellpadding="0" cellspacing="0" width="100%">
    <tr>
      <td align="center" style="padding:20px 0;">
        <!-- Main Container -->
        <table border="0" cellpadding="0" cellspacing="0" width="600" class="container" style="background-color:#ffffff;border-radius:8px;overflow:hidden;">
          <!-- Header -->
          <tr>
            <td align="center" style="background: linear-gradient(90deg, #830095 0%, #830095 33%, #830095 66%, #830095 100%);padding:20px;">
              <img src="https://gana-con-bendicion-en-mano.web.app/assets/images/logo.png" alt="Logo Rifa GANA CON BENDICION EN MANOS" width="150" style="display:block;border:0;outline:none;text-decoration:none;">
            </td>
          </tr>
          <!-- Content -->
          <tr>
            <td style="padding:20px;color:#333333;font-family:Arial,sans-serif;line-height:1.6;">
              ${content}
            </td>
          </tr>
          <!-- Footer -->
          <tr>
            <td style="background-color:#fafafa;padding:20px;font-family:Arial,sans-serif;font-size:12px;color:#666666;text-align:center;border-top:1px solid #e0e0e0;">
              <p style="Margin:0 0 10px;">
                <a href="https://www.instagram.com/ganaconbendicionenmanos" target="_blank" style="color:#666666;text-decoration:none;margin:0 5px;font-size:14px;">Instagram</a>
              </p>
              <p style="Margin:0;font-size:12px;">© ${new Date().getFullYear()} GANA CON BENDICION EN MANOS. Todos los derechos reservados.</p>
              <p style="Margin:5px 0 0;font-size:12px;">v${UI_VERSION}</p>
              <p style="Margin:10px 0 0;">
                <img src="https://gana-con-bendicion-en-mano.web.app/assets/images/conalot-logo.png" alt="Conalot" width="120" style="display:block;margin:0 auto;border:0;outline:none;text-decoration:none;">
              </p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
`;

export const sendPurchaseConfirmation = async (to, name, purchaseId, tickets, totalAmount, referencia) => {
  const ticketList = tickets.map(t => `
    <div class="ticket pending" style="display:inline-block;background:#f8f9fa;border:1px solid #dee2e6;border-radius:20px;padding:8px 16px;font-size:14px;color:#ef6c00;margin:4px 2px;">
      #${String(t.numeroTicket).padStart(4, '0')}
    </div>
  `).join('');

  const countTickets = tickets.length;

  const content = `
    <h2 style="Margin:0 0 15px;font-size:24px;color:#333333;">¡Gracias por tu compra!</h2>
    <p style="Margin:0 0 10px;">Hola <strong>${name}</strong>,</p>
    <p style="Margin:0 0 20px;">Tu compra ha sido registrada exitosamente. Aquí están los detalles:</p>
    
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color:#e3f2fd;padding:15px;margin-bottom:20px;border-left:4px solid #830095;border-radius:0 4px 4px 0;">
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#1565c0;padding:0 0 5px;"><strong>ID de Compra:</strong> ${purchaseId}</td></tr>
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#1565c0;padding:0 0 5px;"><strong>Referencia:</strong> ${referencia}</td></tr>
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#1565c0;"><strong>Monto Total:</strong> Bs. ${totalAmount.toFixed(2)}</td></tr>
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#1565c0;"><strong>Tickets Comprados:</strong> ${countTickets}</td></tr>
    </table>

    <h3 style="Margin:0 0 10px;font-size:18px;color:#333333;">Tus números:</h3>
    <div class="tickets-container">${ticketList}</div>

    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color:#fff3e0;padding:15px;margin-top:20px;border-left:4px solid #f57c00;border-radius:0 4px 4px 0;">
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#ef6c00;"><strong>Importante:</strong> Tu compra está <strong>pendiente de validación</strong>. En breve, recibirás un correo electrónico con la confirmación de tu pago.</td></tr>
    </table>

    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-top:25px;">
      <tr>
        <td align="center">
          <a href="https://wa.me/584263911161" class="whatsapp-button" target="_blank" style="display:inline-block;padding:14px 28px;background:#25D366;color:#ffffff;text-decoration:none;border-radius:30px;font-weight:bold;font-size:16px;text-transform:uppercase;letter-spacing:0.5px;margin:0 auto;">
            Contactar por WhatsApp
          </a>
        </td>
      </tr>
      <tr>
        <td align="center" style="padding-top:15px;">
          <a href="https://gana-con-bendicion-en-mano.web.app/" class="website-button" target="_blank" style="display:inline-block;padding:14px 28px;background:linear-gradient(90deg,#830095 0%,#830095 33%,#830095 66%,#830095 100%);color:#ffffff;text-decoration:none;border-radius:30px;font-weight:bold;font-size:16px;text-transform:uppercase;letter-spacing:0.5px;margin:0 auto;">
            Visitar nuestra web
          </a>
        </td>
      </tr>
    </table>
  `;

  return queueEmail({
    to,
    subject: "Confirmación de Compra - GANA CON BENDICION EN MANOS - " + new Date().toLocaleString('es-VE'),
    body: emailTemplate(content)
  });
};

export const sendPurchaseValidatedEmail = async (to, name, purchaseId, tickets) => {
  if (!tickets || !Array.isArray(tickets)) {
    console.error('sendPurchaseValidatedEmail: tickets inválidos', tickets);
    throw new Error('Los tickets son requeridos para enviar el correo de validación');
  }

  const ticketList = tickets.map(t => `
    <div class="ticket validated" style="display:inline-block;background:#e8f5e9;border:1px solid #81c784;border-radius:20px;padding:8px 16px;font-size:14px;color:#2e7d32;margin:4px 2px;">
      #${String(t.numeroTicket).padStart(4, '0')}
    </div>
  `).join('');

  const content = `
    <h2 style="Margin:0 0 15px;font-size:24px;color:#333333;">¡Pago Validado!</h2>
    <p style="Margin:0 0 10px;">Hola <strong>${name}</strong>,</p>
    <p style="Margin:0 0 20px;">Tu pago ha sido validado exitosamente. Tus números ya están confirmados:</p>
    
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color:#e3f2fd;padding:15px;margin-bottom:20px;border-left:4px solid #830095;border-radius:0 4px 4px 0;">
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#1565c0;"><strong>ID de Compra:</strong> ${purchaseId}</td></tr>
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#1565c0;"><strong>Estado:</strong> Validado</td></tr>
    </table>

    <h3 style="Margin:0 0 10px;font-size:18px;color:#333333;">Tus números validados:</h3>
    <div class="tickets-container">${ticketList}</div>

    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-top:25px;">
      <tr>
        <td align="center">
          <a href="https://wa.me/584263911161" class="whatsapp-button" target="_blank" style="display:inline-block;padding:14px 28px;background:#25D366;color:#ffffff;text-decoration:none;border-radius:30px;font-weight:bold;font-size:16px;text-transform:uppercase;letter-spacing:0.5px;margin:0 auto;">
            Contactar por WhatsApp
          </a>
        </td>
      </tr>
      <tr>
        <td align="center" style="padding-top:15px;">
          <a href="https://gana-con-bendicion-en-mano.web.app/" class="website-button" target="_blank" style="display:inline-block;padding:14px 28px;background:linear-gradient(90deg,#830095 0%,#830095 33%,#830095 66%,#830095 100%);color:#ffffff;text-decoration:none;border-radius:30px;font-weight:bold;font-size:16px;text-transform:uppercase;letter-spacing:0.5px;margin:0 auto;">
            Visitar nuestra web
          </a>
        </td>
      </tr>
    </table>
  `;

  return queueEmail({
    to,
    subject: "Pago Validado - GANA CON BENDICION EN MANOS",
    body: emailTemplate(content)
  });
};

export const sendPurchaseRejectionEmail = async (to, name, motivo) => {
  const content = `
    <h2 style="Margin:0 0 15px;font-size:24px;color:#333333;">Pago Rechazado</h2>
    <p style="Margin:0 0 10px;">Hola <strong>${name}</strong>,</p>
    <p style="Margin:0 0 20px;">Lamentamos informarte que tu pago ha sido rechazado por la siguiente razón:</p>
    
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color:#ffebee;padding:15px;margin-top:20px;border-left:4px solid #830095;border-radius:0 4px 4px 0;">
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#c62828;"><strong>Motivo:</strong> ${motivo}</td></tr>
    </table>

    <p style="Margin:20px 0 0;">Por favor, verifica los detalles de tu pago y vuelve a intentarlo. Si necesitas ayuda, no dudes en contactarnos.</p>

    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-top:25px;">
      <tr>
        <td align="center">
          <a href="https://wa.me/584263911161" class="whatsapp-button" target="_blank" style="display:inline-block;padding:14px 28px;background:#25D366;color:#ffffff;text-decoration:none;border-radius:30px;font-weight:bold;font-size:16px;text-transform:uppercase;letter-spacing:0.5px;margin:0 auto;">
            Contactar por WhatsApp
          </a>
        </td>
      </tr>
      <tr>
        <td align="center" style="padding-top:15px;">
          <a href="https://gana-con-bendicion-en-mano.web.app/" class="website-button" target="_blank" style="display:inline-block;padding:14px 28px;background:linear-gradient(90deg,#830095 0%,#830095 33%,#830095 66%,#830095 100%);color:#ffffff;text-decoration:none;border-radius:30px;font-weight:bold;font-size:16px;text-transform:uppercase;letter-spacing:0.5px;margin:0 auto;">
            Visitar nuestra web
          </a>
        </td>
      </tr>
    </table>
  `;

  return queueEmail({
    to,
    subject: "Pago Rechazado - GANA CON BENDICION EN MANOS",
    body: emailTemplate(content)
  });
};

export const notifyAdminNewPurchase = async (purchaseData) => {
  const adminEmails = [
    'ganaconbendicionenmanos@gmail.com'
  ];

  const ticketList = purchaseData.tickets.map(t => `
    <div class="ticket pending" style="display:inline-block;background:#f8f9fa;border:1px solid #dee2e6;border-radius:20px;padding:8px 16px;font-size:14px;color:#ef6c00;margin:4px 2px;">
      #${String(t.numeroTicket).padStart(4, '0')}
    </div>
  `).join('');

  const countTickets = purchaseData.tickets.length;

  const content = `
    <h2 style="Margin:0 0 15px;font-size:24px;color:#333333;">Nueva Compra Registrada</h2>
    <p style="Margin:0 0 20px;">Se ha registrado una nueva compra en el sistema:</p>
    
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color:#e3f2fd;padding:15px;margin-bottom:20px;border-left:4px solid #830095;border-radius:0 4px 4px 0;">
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#1565c0;padding:0 0 5px;"><strong>ID de Compra:</strong> ${purchaseData.id}</td></tr>
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#1565c0;padding:0 0 5px;"><strong>Comprador:</strong> ${purchaseData.nombre}</td></tr>
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#1565c0;padding:0 0 5px;"><strong>Cédula:</strong> ${purchaseData.cedula}</td></tr>
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#1565c0;padding:0 0 5px;"><strong>Teléfono:</strong> ${purchaseData.telefono}</td></tr>
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#1565c0;padding:0 0 5px;"><strong>Monto Total:</strong> Bs. ${purchaseData.montoTotal.toFixed(2)}</td></tr>
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#1565c0;padding:0 0 5px;"><strong>Tickets Comprados:</strong> ${countTickets}</td></tr>
      <tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#1565c0;"><strong>Referencia:</strong> ${purchaseData.referencia}</td></tr>
      ${purchaseData.comprobanteUrl ? `<tr><td style="font-family:Arial,sans-serif;font-size:14px;color:#1565c0;padding-top:5px;"><strong>Comprobante:</strong> <a href="${purchaseData.comprobanteUrl}" target="_blank">Ver comprobante</a></td></tr>` : ''}
    </table>

    <h3 style="Margin:0 0 10px;font-size:18px;color:#333333;">Números comprados:</h3>
    <div class="tickets-container">${ticketList}</div>

    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-top:25px;">
      <tr>
        <td align="center">
          <a href="https://rgcmadm.web.app" class="website-button" target="_blank" style="display:inline-block;padding:14px 28px;background:linear-gradient(90deg,#830095 0%,#830095 33%,#830095 66%,#830095 100%);color:#ffffff;text-decoration:none;border-radius:30px;font-weight:bold;font-size:16px;text-transform:uppercase;letter-spacing:0.5px;margin:0 auto;">
            Ir al panel de administración
          </a>
        </td>
      </tr>
    </table>
  `;

  const emailPromises = adminEmails.map(email =>
    queueEmail({
      to: email,
      subject: "Nueva Compra - GANA CON BENDICION EN MANOS - " + new Date().toLocaleString('es-VE'),
      body: emailTemplate(content)
    })
  );

  return Promise.all(emailPromises);
};

